import { effectiveBelegdatum, type DokumentDetail } from "@/lib/dokumente";
import { toApiPosition, type EditorPosition } from "@/pages/dokumente/documentPositionModel";

/** Felder, die der Auto-Save-Patch mitschickt — Basis für den Änderungsvergleich. */
export function snapshotDocFields(doc: DokumentDetail) {
  return {
    betreff: doc.betreff ?? null,
    einleitung: doc.einleitung ?? null,
    schlusstext: doc.schlusstext ?? null,
    interne_notiz: doc.interne_notiz ?? null,
    belegdatum: effectiveBelegdatum(doc),
    gueltig_bis: doc.gueltig_bis ?? null,
    leistungsdatum: doc.leistungsdatum ?? null,
    lieferdatum: doc.lieferdatum ?? null,
    leistungszeitraum_von: doc.leistungszeitraum_von ?? null,
    leistungszeitraum_bis: doc.leistungszeitraum_bis ?? null,
    kunde_name: doc.kunde_name ?? null,
    kunde_adresszusatz: doc.kunde_adresszusatz ?? null,
    kunde_strasse: doc.kunde_strasse ?? null,
    kunde_hausnummer: doc.kunde_hausnummer ?? null,
    kunde_plz: doc.kunde_plz ?? null,
    kunde_ort: doc.kunde_ort ?? null,
    kunde_email: doc.kunde_email ?? null,
    kunde_telefon: doc.kunde_telefon ?? null,
    kundennummer: doc.kundennummer ?? null,
    kunden_id: doc.kunden_id ?? null,
    ansprechpartner_id: doc.ansprechpartner_id ?? null,
    ansprechpartner_name: doc.ansprechpartner_name ?? null,
    ansprechpartner_email: doc.ansprechpartner_email ?? null,
    ansprechpartner_telefon: doc.ansprechpartner_telefon ?? null,
    created_by_name: doc.created_by_name ?? null,
    created_by_email: doc.created_by_email ?? null,
    created_by_telefon: doc.created_by_telefon ?? null,
    created_by_mobil: doc.created_by_mobil ?? null,
    bestellnummer: doc.bestellnummer ?? null,
    auftrag_kundenreferenz: doc.auftrag_kundenreferenz ?? null,
    leitweg_id: doc.leitweg_id ?? null,
    rechnung_art: doc.rechnung_art ?? null,
    rechnungsadresse_id: doc.rechnungsadresse_id ?? null,
    reverse_charge_13b: doc.reverse_charge_13b ?? false,
    referenzdokument_anzeigen: doc.referenzdokument_anzeigen !== false,
    exc2_antwort: doc.exc2_antwort ?? null,
  };
}

export function buildEditorSnapshot(doc: DokumentDetail, positions: EditorPosition[]): string {
  return JSON.stringify({
    doc: snapshotDocFields(doc),
    positions: positions.map((row, index) => toApiPosition(row, index, positions)),
  });
}

export function editorHasUnsavedChanges(
  doc: DokumentDetail | null,
  positions: EditorPosition[],
  savedSnapshot: string | null,
  editable: boolean,
): boolean {
  if (!doc || !editable || !savedSnapshot) return false;
  return buildEditorSnapshot(doc, positions) !== savedSnapshot;
}
